import React, {  Component } from 'react';
import Form from 'react-bootstrap/Form';

class ItemDef extends Component {

    constructor(props) {
        super(props);
        this.state = {
            itemDefId: props.itemDefId,
            domainName: props.domainName,
            text: props.text,
            assessmentArea: props.assessmentArea,
            description: props.description,
            displayOrder: props.displayOrder
        }
    }

    domainChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, e.target.value, null, null, null, -1);
        this.setState({ domainName: e.target.value });
    }

    assessmentAreaChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, e.target.value, null, null, -1);
        this.setState({ assessmentArea: e.target.value });
    }

    textChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, null, e.target.value, null, -1);
        this.setState({ text: e.target.value });
    }


    descriptionChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, null, null, e.target.value, -1);
        this.setState({ description: e.target.value });
    }

    displayOrderChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, null, null, null, e.target.value);
        this.setState({ displayOrder: e.target.value });
    }

    render() {
        
        return (
            <tr>
                <td>
                    <Form.Control 
                        type="text"
                        placeholder=""
                        defaultValue={this.state.domainName}
                        onBlur={this.domainChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        placeholder=""
                        defaultValue={this.state.assessmentArea}
                        onBlur={this.assessmentAreaChangeHandler}
                    />
                </td>
                
                <td>
                    <Form.Control 
                        type="text"
                        placeholder=""
                        defaultValue={this.state.text}
                        onBlur={this.textChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="number"
                        placeholder=""
                        defaultValue={this.state.displayOrder}
                        onBlur={this.displayOrderChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        placeholder=""
                        defaultValue={this.state.description}
                        onBlur={this.descriptionChangeHandler}
                    />
                </td>
            </tr>  
        )
    }
}

export default ItemDef;


// WEBPACK FOOTER //
// ./src/components/AdminHome/ItemDef.js